var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFornobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 15,
    viewBox: "0 0 27 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.15952 0H22.168V15H1.15952C0.527056 15 0 14.4835 0 13.8405V1.15952C0 0.516514 0.516514 0 1.15952 0ZM2.01335 13.1026C1.80253 13.1026 1.62333 12.9339 1.62333 12.7231V2.29796C1.62333 2.0766 1.79199 1.88686 2.01335 1.88686H20.1441C20.3549 1.88686 20.5446 2.05552 20.5446 2.29796V12.7231C20.5446 12.9339 20.3549 13.1026 20.1441 13.1026H2.01335ZM2.4877 12.2382V2.75123H19.6803V12.2382H2.4877Z",
    fill: "#E78E2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0312 0H25.3398C25.9722 0 26.4993 0.516514 26.4993 1.15952V13.8405C26.4993 14.4729 25.9828 15 25.3398 15H23.0312V0ZM24.3278 3.04638H25.1922V11.9431H24.3278V3.04638Z",
    fill: "#E78E2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.48828 12.2383V2.75134H19.6808V12.2383H2.48828Z",
    fill: "#E78E2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFornobs);
export default __webpack_public_path__ + "static/media/fornobs.fda471e76146da05ea505d6c54bc78cd.svg";
export { ForwardRef as ReactComponent };